import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { HeaderRow, Body } from '@zendeskgarden/react-tables';

const {
  custom_blue: customBlue,
  color_blue_800: colorBlue800,
  custom_dark_grey: customDarkGrey,
  color_white: colorWhite,
  color_grey_200: colorGrey200,
  color_grey_400: colorGrey400,
} = variables;

export const RelatedListingsWrapper = styled(Body)`
  max-width: 100%;
  max-height: 350px;
  margin: 5px 15px 0;
  background-color: ${colorGrey200};
  border-radius: 1rem;
  .listingRow {
    display: flex;
    flex-wrap: noWrap;
    justify-content: center;
    min-width: 1027px;
    height: 72px;
  }
`;

export const RelatedListingCard = styled('div')`
  width: 100%;
  margin: 0 auto;
  margin-bottom: 2px;
  border: 1px solid ${colorGrey400};
  border-radius: 5px;
  display: flex;
  flex-wrap: noWrap;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  padding: 5px;
  background-color: ${colorWhite};
  &:hover {
    background-color: ${colorGrey200};
    box-shadow: 0 4px 16px #c0cff7;
  }
  .listing_image {
    height: 60px;
    width: 70px;
    border-radius: 2px;
    overflow: hidden;
    object-fit: cover;
    box-shadow: 1px 1px 7px -2px ${customDarkGrey};
  }
  div.Tooltip__TriggerWrapper-lty2bj-1.kvOgTM {
    display: flex;
    align-items: center;
  }
  div.Tooltip__TooltipWrapper-lty2bj-0.hHhGcE[aria-hidden='true'] {
    display: none;
  }
  .tooltip_styling {
    height: 250px;
    max-width: 300px;
    width: 250px;
    background-color: ${colorWhite};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    border-radius: 20px;
  }
  .tooltip_styling.inspection {
    max-width: 500px;
    width: 500px;
    height: 250px;
    background-color: ${colorWhite};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
  .tooltip_listing_image {
    display: flex;
    justify-content: center;
    height: 200px;
    width: 200px;
    border-radius: 2px;
    overflow: hidden;
    object-fit: cover;
    margin: 5px;
  }
  .tooltipListingName {
    color: ${customBlue};
    font-weight: 600;
    margin: 5px 0;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
  }
  .listingName {
    min-width: 250px;
    color: ${customBlue};
    &:hover {
      cursor: pointer;
    }
  }
  .listingQuantity {
    min-width: 166px;
    display: flex;
    justify-content: center;
  }
  .listingManufacturer {
    min-width: 166px;
  }
  .listingLocation {
    min-width: 250px;
  }
  .defaultImage_listing {
    height: 60px;
    width: 70px;
    background-image: url('/images/logo-grey-pipe.svg');
    background-repeat: no-repeat;
    background-size: 100%;
    box-shadow: 1px 1px 7px -2px ${customDarkGrey};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
  }
  .defaultImage {
    height: 200px;
    width: 200px;
    background-image: url('/images/logo-grey-pipe.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  .withIcon {
    display: flex;
    flex-wrap: noWrap;
    align-items: center;
  }
  .listingIcon {
    padding-right: 20px;
  }
  .heartIcon {
    position: absolute;
    top: -10%;
    left: 60%;
  }
  .actionIcons {
    &:hover {
      cursor: pointer;
    }
  }
  .listingInspectionTooltipHeader {
    display: flex;
    flex-wrap: noWrap;
    align-items: flex-end;
    justify-content: space-evenly;
    margin: 20px 0 10px;
  }
  .listingInspectionList {
    display: flex;
    color: black;
    flex-wrap: wrap;
    flex-direction: column;
    height: 150px;
    margin-left: 20px;
  }
  .listingInspectionItem {
    font-size: 12px;
    display: flex;
    flex-wrap: noWrap;
    margin-left: 10px;
  }
  @media (max-width: 550px) {
    .tooltip_styling.inspection {
      max-width: 400px;
      width: 400px;
    }
    .listingInspectionTooltipHeader {
      flex-wrap: wrap;
    }
    .listingInspectionList {
      margin-left: 10px;
    }
  }
  @media (max-width: 475px) {
    .tooltip_styling.inspection {
      display: none;
    }
  }
`;

export const HeaderTitles = styled(HeaderRow)`
  background-color: ${colorBlue800};
  color: ${colorWhite} !important;
  border-radius: 0.3em;
`;
